module.exports = __webpack_public_path__ + "img/AppStoreWhite.942df322.svg";